import React, { useEffect, useState } from 'react';
import { useParams, Link } from "react-router-dom";
import { httpRequest } from '../../../helpers/httpService';
import appConfig from '../../../config/env';
import images from '../../../helpers/images';
import helpers from '../../../helpers/helpers';
import moment from 'moment';

function EventDetail (){
    let { slug } = useParams();
    const api_url = appConfig.apiUrl;
    const [event_data, setEvent] = useState({});
    const [data_loaded, setDataLoaded] = useState(0);

    useEffect(() => {
        //Mounted
        window.scrollTo(0,0);
        getEventData();
    }, []);

    function getEventData() {
        const url = api_url + '/public/events/'+slug;

        httpRequest(url, "GET")
            .then((res) => {
                setEvent(res);
                setDataLoaded(1)
            })
            .catch((err) => {
                setDataLoaded(1)
            });
    }

    function registrationNote(data){
        const start_date = moment(data.registration_start_date)
        let display = 'Registration will start on ';
        if(data.registration_start_time !='00:00:00'){
            display += moment(data.registration_start_date + ' ' + data.registration_start_time).format('(ddd) MMM DD, YYYY h:mmA');
        }else{
            display += start_date.format('(ddd) MMM DD, YYYY');
        }
        //return display

        return 'Registration is Closed'
    }

    
    const has_content = 
            <div>
            <div id="banner" className="p-5 text-center bg-image" style={{backgroundImage: `url(${images.pageBanner})`, backgroundRepeat: 'no-repeat', backgroundSize: 'cover'}}>
                    <h2 className="event-banner-title">Events</h2>
                </div>

                <div className="container mt-4">
                    <div className="row">
                        <div className="col">
                        <img src={ helpers.getFileURL(event_data.image_banner)} className="d-flex justify-content-lg-start accordion-item-start" style={{width: '100%', height: '100vh', objectFit: 'cover'}} />
                        </div>
                    </div>
                </div>

                <section>
                <div className="container">
                    <div className="row">
                    <div className="col-12 col-md-7 mt-5">
                        <h1 className="event-header">{event_data.title}</h1>

                        <div className="event-content" dangerouslySetInnerHTML={{__html: event_data.details}} />
                    </div>
                    <div className="col-12 col-md-5 mt-5">
                        <div className="card">
                            <div className="card-body">
                                <h5 className="event-card-title">Date &amp; Time</h5>
                                <p className="event-card-details">{helpers.displayDateTime(event_data)}</p>
                                <h5 className="event-card-title">Location</h5>
                                <p className="event-card-details gx-2">
                                    <img src={images.locationIcon} alt="location" className="locatioon_icon-event" />&nbsp;
                                    {event_data.venue_type == 'physical' ? (
                                            event_data.address
                                        ) : (
                                        `Online`
                                        )}
                                    
                                </p>
                                <h5 className="event-card-title">Tickets</h5>
                                <p className="event-card-details">{helpers.displayPriceLabel(event_data)}</p>

                                
                            </div>
                        </div>

                        {helpers.registrationStatus(event_data) == 'open' && <Link to={'/registration/event/'+event_data.id} className="btn btn-register w-100">Register</Link>}
                        
                        {helpers.registrationStatus(event_data) == 'close' && 
                        <>
                            <div className='alert alert-secondary text-center mt-4'>Registration is Close</div>
                            <Link to="/" className="btn btn-register w-100">Go to Events</Link>
                            {/* <button type="buttom" className="btn btn-color-event w-100">{registrationNote(event_data)}</button> */}
                        </>
                        }

                        {helpers.registrationStatus(event_data) == 'completed' &&  
                            <>
                            <div className='alert alert-secondary text-center mt-4'>Completed</div>
                            {/* <Link to="/" className="btn btn-register w-100">Go to Events</Link> */}
                            </>
                        }
                        
                    </div>
                    </div>
                </div>
            </section> 
        </div>

    const no_content = <section className="faith h-100">
                            <div className="container">
                                <div className="parent" style={{width: '100%', minHeight: '700px'}}>
                                    <div className="container d-flex flex-column justify-content-center align-items-center">
                                        <h1 className="success-title text-center">Oopps! Event not found.</h1>

                                        
                                        <p className="success-text mb-5 text-center">We can't seem to find the event you're looking for.</p>
                                        <Link to='/' className="btn btn-return py-3">Return to Events</Link>
                                    </div>
                                </div>
                            </div>
                        </section>

    const fetching = <section className="faith h-100">
                        <div className="container">
                            <div className="parent" style={{width: '100%', minHeight: '700px'}}>
                                <div className="container d-flex flex-column justify-content-center align-items-center">
                                    <h1 className="success-title text-center">Loading Data. Please Wait...</h1>
                                </div>
                            </div>
                        </div>
                    </section>


    return (
        <>

        {/* {Object.keys(event_data).length === 0 ? (fetching) : (has_content) } */}

        {
            !data_loaded ? 
            fetching
            :
            <div>
                {Object.keys(event_data).length === 0 ? no_content : has_content }
            </div>
        }

        </>
    )
}
 
export default EventDetail;